import { getRowDefaultCategoryMode } from '@/lib/utils';
export default class TextConverter {
  toQuery(defaultInfo, { fieldDetail, isRow }) {
    const info = { ...defaultInfo };

    if (isRow) {
      info.relationType = '分类';
      info.agg_type = 'term';
    } else {
      info.relationType = '实体';
      info.agg_type = 'row_sum';
    }

    info.deputy_field_type = getRowDefaultCategoryMode(fieldDetail) ? 'dict' : '';

    return info;
  }

  toFrontEndVal() {
    return JSON.stringify({});
  }
}
